import api from '@/api'
import { sortBy } from 'lodash'

export default {
  namespaced: true,

  state: () => ({
    data: []
  }),

  actions: {
    get: async function (ctx, params) {
      const response = await api.get(`/v1/units`, params)

      ctx.commit('set', response.data)
    }
  },

  mutations: {
    set: function (state, units) {
      state.data = sortBy(units, 'name')
    },

    add: function (state, unit) {
      const units = [...state.data]

      units.push(unit)

      state.data = sortBy(units, 'name')
    },

    update: function (state, unit) {
      const units = [...state.data]

      const unitIndex = units.findIndex(u => u._id === unit._id)

      if (unitIndex >= 0) {
        units[unitIndex] = unit
      } else {
        units.push(unit)
      }

      state.data = sortBy(units, 'name')
    },

    delete: function (state, unit) {
      const units = [...state.data]

      const unitIndex = units.findIndex(u => u._id === unit._id)

      if (unitIndex >= 0) {
        units.splice(unitIndex, 1)
      }

      state.data = units
    },

    reset: function (state) {
      state.data = []
    }
  },

  getters: {
    forInventory (state) {
      return state.data.filter(unit => ['pz', 'kg', 'l'].includes(unit.code))
    }
  }
}
